// extracted by mini-css-extract-plugin
module.exports = {"submenu":"UserMenu_submenu__3ccCE","open":"UserMenu_open__36b3D"};